import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const PersonIcon: FC<SvgProps> = ({ fill, ...props }) => {
    return (
        <Svg viewBox="0 0 16 16" height={16} width={16} {...props}>
            <Path
                fill={fill || 'currentColor'}
                d="M8.001 7.917c-.8 0-1.466-.27-2-.809-.533-.539-.8-1.202-.8-1.991 0-.8.267-1.467.8-2 .534-.534 1.2-.8 2-.8s1.467.266 2 .8c.534.533.8 1.2.8 2 0 .789-.267 1.452-.8 1.991-.533.54-1.2.809-2 .809Zm3.934 5.617H4.068a1.53 1.53 0 0 1-1.125-.459 1.53 1.53 0 0 1-.459-1.125v-.467a2.03 2.03 0 0 1 1.15-1.866 10.228 10.228 0 0 1 2.142-.759 9.766 9.766 0 0 1 4.459 0c.744.173 1.455.42 2.133.742.344.166.622.417.833.75.211.333.317.71.317 1.133v.467c0 .445-.153.82-.458 1.125a1.53 1.53 0 0 1-1.125.459ZM4.068 11.95h7.867v-.45a.582.582 0 0 0-.084-.317.291.291 0 0 0-.216-.15A7.932 7.932 0 0 0 9.86 10.4 8.26 8.26 0 0 0 8 10.183c-.611 0-1.23.075-1.858.225-.628.15-1.22.359-1.775.626a.455.455 0 0 0-.216.166.501.501 0 0 0-.084.3v.45ZM8 6.334c.356 0 .648-.114.875-.342.228-.228.342-.52.342-.875 0-.356-.114-.648-.342-.875-.227-.228-.52-.342-.875-.342-.356 0-.647.114-.875.342-.228.227-.342.519-.342.875 0 .355.114.647.342.875.228.228.52.342.875.342Z"
            />
        </Svg>
    )
}

export default PersonIcon
